import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { CustomRoleDto, CustomRolesApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseGetCustomRole = (
  id: string,
  options: Omit<
    UseQueryOptions<CustomRoleDto, ErrorResponse, CustomRoleDto, string[]>,
    'queryKey' | 'queryFn'
  >,
) => UseQueryResult<CustomRoleDto>;

export const useGetCustomRole: UseGetCustomRole = (id, options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const customRolesApi = new CustomRolesApi(getApiConfiguration());
  return useQuery(
    [`custom-role-${id}`],
    async () => customRolesApi.getCustomRole(tenantId, id).then((res) => res.data),
    options,
  );
};
